<template>
  <div v-wave
       class="p-3 relative md:w-[400px] md:bg-white border rounded-md"
       :class="[
         !service.visible && 'opacity-50',
         reorderMode ? 'cursor-move select-none' : 'md:hover:bg-gray-50 md:cursor-pointer'
       ]"
       @click="editIfPossible">
    <div class="flex flex-row items-start gap-3">
      <i v-if="reorderMode" class="pi pi-bars text-gray-400 mt-8 flex-none" />
      <div class="flex flex-col gap-4 w-full">
        <div class="flex flex-row items-start">
          <img
            :src="service.imageUrl || DEFAULT_LOGO_IMAGE"
            alt="תמונה של השירות"
            class="w-20 h-20 rounded-md ml-4"
          />
          <div class="flex flex-col w-full gap-1">
            <span class="font-medium">{{ service.name }}</span>
            <span v-if="service.description" class="text-sm">{{ service.description }}</span>
            <span v-if="service.category"
                  class="mt-1 w-max text-xs rounded-full border border-primary-200 bg-primary-50 text-primary-700 px-2 py-0.5">
              {{ service.category }}
            </span>
          </div>
        </div>
        <div class="w-full grid grid-cols-2">
          <div class="flex flex-col gap-1 pe-4">
            <span class="text-xs text-gray-500">אורך השירות</span>
            <span class="text-sm">{{ resolveServiceDuration(service) }}</span>
          </div>
          <div class="flex flex-col gap-1 pe-4">
            <span class="text-xs text-gray-500">מחיר</span>
            <span class="text-sm">{{ formatServicePrice(service) }}</span>
          </div>
        </div>
        <span v-if="service.selectedClientsOnly"
              class="font-medium py-1 px-2 text-xs rounded-md flex-none w-max text-yellow-600 border border-yellow-600 bg-yellow-200">ללקוחות נבחרים בלבד</span>
      </div>
    </div>

  </div>
</template>

<script setup lang="ts">

import { DEFAULT_LOGO_IMAGE } from '@app/types';
import { computed, PropType } from 'vue';
import { useAdminStore } from '@app/stores';
import { IService } from '@torim-app/types';
import { formatServicePrice, resolveServiceDuration } from '@torim-app/utils';

const emit = defineEmits(['clickedEdit']);
const props = defineProps({
  service: {
    type: Object as PropType<IService>,
    required: true
  },
  reorderMode: {
    type: Boolean,
    required: false,
    default: false
  }
});

const adminStore = useAdminStore();

const isMainClient = computed(() => adminStore.getMainClient);
const onlyAllowedToChoose = computed(() => {
  return !adminStore.getBusinessSiteData?.configurations?.allowEmployeeToCreateServices && !isMainClient.value;
});

const editIfPossible = () => {
  if (props.reorderMode) return;
  if (!onlyAllowedToChoose) return;
  emit('clickedEdit', props.service);
};

</script>

<style scoped lang="scss">

</style>
